(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tripxkeke-shop-dna"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('txk-dna-hero')) {
    customElements.define('txk-dna-hero', class extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas.getContext('2d');
        if (!this.context) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.resize = new ResizeObserver(() => {
          this.width = this.clientWidth;
          this.height = this.clientHeight;
          const ratio = Math.min(devicePixelRatio || 1, 1.5);
          this.canvas.width = this.width * ratio;
          this.canvas.height = this.height * ratio;
          this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
          this.draw(this.phase || 0);
        });
        this.resize.observe(this);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.start();
        });
        this.observer.observe(this);
        this.changed = () => this.start();
        this.motion.addEventListener('change', this.changed);
      }
      start() {
        cancelAnimationFrame(this.frame);
        if (!this.visible || this.motion.matches) { this.draw(0); return; }
        const loop = time => {
          this.phase = (time % 16000) / 16000 * Math.PI * 2;
          this.draw(this.phase);
          this.frame = requestAnimationFrame(loop);
        };
        this.frame = requestAnimationFrame(loop);
      }
      draw(phase) {
        if (!this.width || !this.height) return;
        const c = this.context, w = this.width, h = this.height;
        c.clearRect(0, 0, w, h);
        const mobile = w < 600;
        const helices = [
          { x: mobile ? .14 : .23, rotation: -.35, offset: 0, color: '#ff448f' },
          { x: mobile ? .88 : .8, rotation: .35, offset: Math.PI, color: '#689aff' }
        ];
        helices.forEach(dna => {
          c.save();
          c.translate(w * dna.x + Math.sin(phase + dna.offset) * w * .035, h * .5 + Math.cos(phase + dna.offset) * 20);
          c.rotate(dna.rotation + Math.sin(phase) * .08);
          const length = h * 1.55, radius = Math.min(w * .085, 112);
          const point = (y, side) => ({ x: Math.sin(y / 64 + phase * 2 + dna.offset + side * Math.PI) * radius, y });
          c.lineWidth = 1.3;
          for (let y = -length / 2; y < length / 2; y += 22) {
            const a = point(y, 0), b = point(y, 1);
            c.globalAlpha = .25 + .2 * Math.abs(Math.cos(y / 64 + phase * 2));
            c.strokeStyle = dna.color;
            c.beginPath(); c.moveTo(a.x, a.y); c.lineTo(b.x, b.y); c.stroke();
          }
          c.shadowColor = dna.color; c.shadowBlur = 13;
          for (let side = 0; side < 2; side++) {
            c.globalAlpha = .72; c.strokeStyle = side ? '#ef95d0' : dna.color; c.lineWidth = 2.3;
            c.beginPath();
            for (let y = -length / 2; y <= length / 2; y += 3) { const p = point(y, side); if (y === -length / 2) c.moveTo(p.x, p.y); else c.lineTo(p.x, p.y); }
            c.stroke();
            for (let y = -length / 2; y < length / 2; y += 22) { const p = point(y, side); c.fillStyle = dna.color; c.beginPath(); c.arc(p.x, p.y, 2.8, 0, Math.PI * 2); c.fill(); }
          }
          c.restore();
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resize?.disconnect(); this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.changed);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
